module.exports = __webpack_public_path__ + "img/discount-sale-back2.e59434d2.png";